import React from 'react';
import { ArrowUpIcons } from '../../icons/icons';
import { StatsData } from './types';

interface StatsCardsProps {
  activeUsers: number;
  totalOrganizations: number;
}

const StatsCards: React.FC<StatsCardsProps> = ({ activeUsers, totalOrganizations }) => {
  return (
    <div className='grid grid-cols-1 md:grid-cols-3 gap-6 mb-8'>
      { /* Total Organizations */ }
      <div className='bg-white p-6 rounded-[2rem] border border-slate-100 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden group'>
        <div className='flex justify-between items-start mb-4'>
          <div>
            <p className='text-[11px] font-bold text-slate-400 uppercase tracking-widest mb-1'>Total Organizations</p>
            <h3 className='text-3xl font-black text-slate-800 tracking-tighter'>{ totalOrganizations }</h3>
          </div>
          <div className='w-10 h-10 bg-emerald-50 rounded-2xl flex items-center justify-center text-emerald-600 group-hover:bg-emerald-600 group-hover:text-white transition-colors'>
            <svg className='w-5 h-5' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4' />
            </svg>
          </div>
        </div>
        { /*<div className='flex items-center gap-1'>*/ }
        { /*  <span className='text-emerald-500 text-xs font-bold flex items-center'>*/ }
        { /*    <ArrowUpIcons className='w-3 h-3 mr-0.5' />*/ }
        { /*    +{ stats.totalOrganizationsTrend }%*/ }
        { /*  </span>*/ }
        { /*  <span className='text-slate-400 text-[10px] font-medium'>from last month</span>*/ }
        { /*</div>*/ }
        <div className='absolute top-0 right-0 w-24 h-24 bg-emerald-50/30 rounded-full blur-3xl -mr-12 -mt-12 group-hover:bg-emerald-100/40 transition-colors' />
      </div>

      { /* Active Users */ }
      <div className='bg-white p-6 rounded-[2rem] border border-slate-100 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden group'>
        <div className='flex justify-between items-start mb-4'>
          <div>
            <p className='text-[11px] font-bold text-slate-400 uppercase tracking-widest mb-1'>Active Users</p>
            <h3 className='text-3xl font-black text-slate-800 tracking-tighter'>{ activeUsers.toLocaleString() }</h3>
          </div>
          <div className='w-10 h-10 bg-blue-50 rounded-2xl flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors'>
            <svg className='w-5 h-5' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z' />
            </svg>
          </div>
        </div>
        { /*<div className='flex items-center gap-1'>*/ }
        { /*  <span className='text-emerald-500 text-xs font-bold flex items-center'>*/ }
        { /*    <ArrowUpIcons className='w-3 h-3 mr-0.5' />*/ }
        { /*    +{ stats.activeUsersTrend }%*/ }
        { /*  </span>*/ }
        { /*  <span className='text-slate-400 text-[10px] font-medium'>from last month</span>*/ }
        { /*</div>*/ }
        <div className='absolute top-0 right-0 w-24 h-24 bg-blue-50/30 rounded-full blur-3xl -mr-12 -mt-12 group-hover:bg-blue-100/40 transition-colors' />
      </div>

      { /* Health Score */ }
      <div className='bg-white p-6 rounded-[2rem] border border-slate-100 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden group'>
        <div className='flex justify-between items-start mb-4'>
          { /*<div>*/ }
          { /*  <p className='text-[11px] font-bold text-slate-400 uppercase tracking-widest mb-1'>Avg. Health Score</p>*/ }
          { /*  <h3 className='text-3xl font-black text-slate-800 tracking-tighter'>{ stats.avgHealthScore }%</h3>*/ }
          { /*</div>*/ }
          <div className='w-10 h-10 bg-emerald-50 rounded-2xl flex items-center justify-center text-emerald-600 group-hover:bg-emerald-600 group-hover:text-white transition-colors'>
            <svg className='w-5 h-5' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z' />
            </svg>
          </div>
        </div>
        <div className='flex items-center gap-1'>
          <span className='text-slate-500 text-[11px] font-bold'>Standard across all tenants</span>
        </div>
        <div className='absolute top-0 right-0 w-24 h-24 bg-emerald-50/30 rounded-full blur-3xl -mr-12 -mt-12 group-hover:bg-emerald-100/40 transition-colors' />
      </div>
    </div>
  );
};

export default StatsCards;
